import { useState } from 'react';
import { T, AppHeader } from '../design';
import { usePortal } from '../context/PortalContext';
import { AdminSalons } from '../modules/courses/screens/AdminSalons';
import { AdminEmployees } from '../modules/courses/screens/AdminEmployees';

const MAIN_PAD = '18px 14px calc(36px + env(safe-area-inset-bottom))';

/**
 * Admin-tilstand: en intern bruger vælger en salon i sit Mira-scope og en medarbejder.
 * Valget starter en impersonation på serveren; derefter kører modulet som medarbejderen.
 */
export function AdminPicker({ onBack }: { onBack: () => void }) {
  const portal = usePortal();
  const [step, setStep] = useState<'salon' | 'employee'>('salon');
  const salonName = portal.availableSalons.find((s) => s.id === portal.selectedSalonId)?.name ?? '';

  return (
    <>
      <AppHeader
        eyebrow="Admin-mode"
        title={step === 'salon' ? 'Vælg salon' : 'Vælg medarbejder'}
        onBack={step === 'salon' ? onBack : () => setStep('salon')}
      />
      <main style={{ flex: 1, padding: MAIN_PAD, background: T.bg }}>
        {step === 'salon' ? (
          <AdminSalons salons={portal.availableSalons} onPick={(s) => { portal.selectSalon(s.id); setStep('employee'); }} />
        ) : (
          <AdminEmployees salonName={salonName} employees={portal.availableEmployees} onPick={(e) => portal.selectEmployee(e.id)} />
        )}
      </main>
    </>
  );
}
